import { isMobile } from "pixi.js";
import { DesktopApplicationWrapper } from "./DesktopApplicationWrapper";
import { MobileApplicationWrapper } from "./MobileApplicationWrapper";

export const ApplicationWrapper = () => {
  if (isMobile.phone) {
    return <MobileApplicationWrapper />;
  } else {
    return <DesktopApplicationWrapper />;
  }
};
